module.exports = __webpack_public_path__ + "static/media/status_4.a8b6c1b0.svg";